import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=bb727a8a&scoped=true"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=bb727a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb727a8a",
  null
  
)

export default component.exports